// extracted by mini-css-extract-plugin
export default {"container_loading":"Loading_container_loading__ZiYEi"};